import type { IInsightCategory } from "../types";

const NUM_OF_VISIBLE_CATEGORIES = 14;

export function splitInsightCategoriesForNav(categories: IInsightCategory[]) {
  return {
    visibleCategories: categories.slice(0, NUM_OF_VISIBLE_CATEGORIES),
    overflowCategories: categories.slice(NUM_OF_VISIBLE_CATEGORIES),
  };
}
